import type { DragEvent } from '@/components/core-components/StanDraggable/StanDraggable.types';
import type { ProductItem, SectionItem, StoreItem } from '../types/myStore.types';

export interface ReorderPayload {
    sections: Array<{ section_id: number; order: number }>;
    pages: Array<{ page_id: number; order: number }>;
}

export function handleStoreItemsReorder(
    event: DragEvent,
    storeItems: StoreItem[],
    filteredItems: StoreItem[]
): { updatedItems: StoreItem[]; payload: ReorderPayload } {
    const newOrder = event.allItems.map(item => item.id);

    const reorderedFiltered = newOrder
        .map(id => filteredItems.find(item => item.id === id))
        .filter((item): item is StoreItem => item !== undefined);

    const reorderedIds = new Set(reorderedFiltered.map(item => item.id));

    const nonReorderedItems = storeItems.filter(item => !reorderedIds.has(item.id));

    const insertIndex = storeItems.findIndex(item => reorderedIds.has(item.id));

    const itemsBeforeInsert =
        insertIndex >= 0 ? storeItems.slice(0, insertIndex).filter(item => !reorderedIds.has(item.id)).length : 0;

    const updatedItems = [
        ...nonReorderedItems.slice(0, itemsBeforeInsert),
        ...reorderedFiltered,
        ...nonReorderedItems.slice(itemsBeforeInsert),
    ];

    const sections: SectionItem[] = [];
    const pages: ProductItem[] = [];

    reorderedFiltered.forEach((item, index) => {
        const newOrder = (insertIndex >= 0 ? insertIndex : 0) + index + 1;
        if (item.type === 'section') {
            sections.push({ ...item, order: newOrder } as SectionItem);
        } else {
            pages.push({ ...item, order: newOrder } as ProductItem);
        }
    });

    const payload: ReorderPayload = {
        sections: sections.map(section => ({
            section_id: section.section_id,
            order: section.order,
        })),
        pages: pages.map(page => ({
            page_id: page.page_id,
            order: page.order,
        })),
    };

    return { updatedItems, payload };
}
